import { AgentDetails, useGetAgencyMembers } from '@urbanx/agx.agencies.client'
import { useMemo } from 'react'
import useAgentIdParam from './useAgentIdParam'
import useAgencyIdParam from './useAgencyIdParam'

const useSelectedAgent = (): {
  agent?: AgentDetails
  isPending: boolean
} => {
  const agentId = useAgentIdParam()
  const agencyId = useAgencyIdParam();

  const { data: agents, isPending } = useGetAgencyMembers(agencyId!, !!agencyId)

  const selectedAgent = useMemo(() => {
    if (!agents) return undefined

    return agents.find((agent) => agent.id === agentId)
  }, [agents, agentId])

  return {
    agent: selectedAgent,
    isPending,
  }
}

export default useSelectedAgent
